import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { HEADER_NAV_ITEMS } from '@shared/constants/navigation';

export function NavMenu() {
  return (
    <nav className="hidden md:flex items-center space-x-6">
      {HEADER_NAV_ITEMS.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className={`text-sm font-medium transition-colors ${
            item.highlight
              ? item.icon === 'Star'
                ? 'flex items-center gap-1 text-amber-600 hover:text-amber-700'
                : 'text-brand-mauve hover:text-brand-plum'
              : 'text-brand-carbon hover:text-brand-mauve'
          }`}
        >
          {item.icon === 'Star' && <Star className="h-4 w-4 fill-amber-600" />}
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
